<div class="col-12" *ngIf="!spinner">
    <div class="card">
        <div class="title" style="padding: 7px;">{{item?.name}}</div>
        <div class="grid formgrid col-12" >
            <div *ngIf="!item.url" [innerHTML]="item.contentHtml | safecomment" class="content-container"></div>
        </div>
    </div>
</div>
<!--    Spinner here -->
<div *ngIf="spinner">
  <div class="progress-spinner">
    <p-progressSpinner *ngIf="spinner" strokeWidth="2">
    </p-progressSpinner>
  </div>
</div>
